import { Autocomplete, Backdrop, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton, Paper, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
import {  Delete, EditNote, PictureAsPdf, Print } from "@mui/icons-material";
import { setPDFData } from "../../../../../components/hooks/printPdf/pdfData";
import {  useNavigate } from "react-router-dom";
import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
import { CSVLink } from "react-csv";
import FastRewindIcon from '@mui/icons-material/FastRewind';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Loader from "../../../../../components/loader/loader";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import DetailsModal from "./bycustomer";
const CustomerWiseSalesReport = () => {
  const classes = useStyle()
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [customerdata, setCustomerData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [rowData, setRowData] = useState(null)
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
  const [totalCard , setTotalCard] = useState(0) // overall amount in footer
  const [totalCash , setTotalCash] = useState(0) // overall amount in footer
  const [totalUpi , setTotalUpi] = useState(0) // overall amount in footer
  const [totalCGST , setTotalCGST] = useState(0) // overall amount in footer
  const [totalSGST , setTotalSGST] = useState(0) // overall amount in footer
  const [totalLessAmount , setTotalLessAmount] = useState(0) // overall amount in footer
  const [totalLoyal , setTotalLoyal] = useState(0) 
  const [totalReturnAmount , setTotalReturnAmount] = useState(0) // overall amount in footer
  const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const outletId = localStorage.getItem('outlet_id')
  const roleId = localStorage.getItem("role_id")
  const [openMode, setOpenMode] = useState(false)
  const [openModeMixed, setOpenModeMixed] = useState(false)
  const [loading, setLoading] = useState(false);
  const [totalDiscount, setTotalDiscount] = useState(0); // Add this line
  const[mixedPayDetails , setMixedPayDetails] = useState({
    cash : 0,
    card : 0,
    upi : 0
  })
  const[mixedTotal , setMixedTotal] = useState(0);
  const [salesData, setSalesData] = useState(null);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [dateLimit, setDateLimit] = useState({
    // fromDate : roleId != 1 && roleId != 2 ? moment().format() : moment().startOf('month').format(),
    fromDate :  moment().format(),
    toDate :  moment().format()
  })
  const [activeRow, setActiveRow] = useState(null)
  const[cust, setCust] = useState(null)
  const [payMode, setPayMode] = useState("")
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedRowData, setSelectedRowData] = useState(null);
const [selectedCustomerData, setSelectedCustomerData] = useState(null);
  const [search, setSearch] = useState('')

console.log(pageCount,"pageCount");
  
  const onEdit = (e) => {
    console.log(e.row)
    setSalesLines(e.row.sales_lines)
    setRowData(e.row)
    setOpen(true)
  }
  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

  
  const convertNumber = (num) => {
    if (num === 0) return 'Zero';

    let words = '';
    for (let i = 0; num > 0; i++) {
      if (num % 1000 !== 0) {
        words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
      }
      num = Math.floor(num / 1000);
    }
    return words.trim();
  };

  const convertHundreds = (num) => {
    if (num >= 100) {
      return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
    } else {
      return convertTens(num);
    }
  };

  const convertTens = (num) => {
    if (num < 10) return units[num];
    else if (num < 20) return teens[num - 10];
    else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
  };
  function handlePDF(e){
    console.log(e)
    const TotalData = {
      sub_total : e.sub_total,
      cess_amt : e.cess,
      gst: e.gst_Amt,
      totalAmount : e.tot,
      roundOff : e.roff,
    }
    const tableData = _.map(e.sales_lines, (val=>({
      pro_name : val.pro_name,
      sale_rate:val.mrp,
      qty:val.qty,
      disc1:val.dis_per,
      cgstPerc:val.gst_per,
      cgstAmnt : val.gst_amt,
      totalAmt:val.rate * val.qty,
      hsn: val.hsn,
    })))
    console.log(TotalData)
    axios.post(`/v1/outlet_sales_master/getall`,{docno : e.billNo})
    .then(res=>{
    dispatch(setPDFData({
      tableData : tableData,
      TotalData : TotalData,
      companyInfo : res.data,
      totalText : convertNumber(e.tot),
      title:'Sales Invoice',
      
    }))      
    const name = `BillNo_${e.billNo}`
    navigate(`/invoice/${name}`)  
    })
    .catch(err=>{
      console.log(err)
      dispatch(
        setSnackbar(true, "error", err.response.data.errors[0].message)
      );
    })
    
    
    // dispatch(setPDFData({
    //   tableData : e.purchase_lines,
    //   // TotalData : 
    // }))
    }
    console.log(data,"datttttttt");
    
function handleThermal(e){
console.log('Working!',e)
console.log(e)

const tableData = _.map(e.sales_lines, (val=>({
  pro_name : val.pro_name,
  sale_rate:val.rate,
  qty:val.qty,
  disc1:val.dis_per,
  mrp: val.mrp,
  cgstPerc:val.gst_per,
  cgstAmnt : val.gst_amt,
  totalAmt:val.rate * val.qty,
  hsn: val.hsn,
})))
axios.post(`/v1/outlet_sales_master/getall`,{docno : e.billNo})
.then(res=>{
  const TotalData = {
    sub_total : Number(e.sub_total),
    gst: e.gst_Amt,
    totalAmount : Number(e.tot),
    roundOff : e.roff,
    returnAmnt: res.data.return_amount
  }
dispatch(setThermalData({
  tableData : tableData,
  TotalData : TotalData,
  companyInfo : res.data,
  totalText : convertNumber(e.tot),  
  redeemedValue:  e.RetAmt,
  lessAmount : e.lessAmount,
  redeemedValue : e.loyalty_redem
}))      
dispatch(onPressButton())
const name = `BillNo_${e.billNo}`
navigate(`/sales/${name}`)  
})
.catch(err=>{
  console.log(err)
  dispatch(
    setSnackbar(true, "error", err.response.data.errors[0].message)
  );
})

    }
 
function handleModeChange (e){
  console.log(e)
  setActiveRow(e)
  console.log(e.mode)
  if(e.mode == "mixed" || e.mode == "Mixed"){
    setOpenModeMixed(true)
    setMixedPayDetails((prev) => ({...prev, cash : e.cash_amt , card:e.card_amt , upi:e.upi_amt , }))
    setMixedTotal(e.cash_amt + e.card_amt + e.upi_amt) 
    setPayMode(e.mode)
  }else{
    setOpenMode(true)
    setMixedPayDetails((prev) => ({...prev, cash : e.cash_amt , card:e.card_amt , upi:e.upi_amt , }))
    setMixedTotal(e.cash_amt + e.card_amt + e.upi_amt) 
  }
}    
console.log(activeRow)
console.log(payMode)
const handleInputChange = (event) => {
  const { name, value } = event.target;
  const numericValue = value.replace(/[^0-9]/g, '');
  setMixedPayDetails((prev) => ({ ...prev, [name]: numericValue !== '' ? Number(numericValue) : 0}));
};
console.log(mixedPayDetails)
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  // {
  //   field: "date1",
  //   headerName: "Date",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "time",
  //   headerName: "Time",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  {
    field: "party",
    headerName: "Customer Name",
    minWidth: 130,
    headerAlign: "center",
    flex:1,
    align: "center",
    sortable: false,
  },
  {
    field: "mobile",
    headerName: "Mobile",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

 
  {
    field: "amt",
    headerName: "Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_sales_count",
    headerName: "Sales Count",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_loyalty_earned",
    headerName: "Loyalty Earned",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_loyalty_redemed",
    headerName: "Loyalty Redeem",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "balance_points",
    headerName: "Balance Point",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "view",
    headerName: "View",
    disableExport: true ,
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      // console.log(params.row)
      return (
        <div>
          {/* <IconButton size="small" onClick={() => onEdit(params)}>
          <VisibilityIcon sx={{fontSize: 18}} />
        </IconButton>
    */}
    <IconButton
          size="small"
          onClick={() => {
            setSelectedRowData(params.row);
            
            setIsModalOpen(true);
            handleViewByCustomer(params.row.mobile)
          }}
          // onClick={()=>handleModal()}
          // onClick={() => handleViewByCustomer(params.row.mobile)}
        >
          <VisibilityIcon sx={{ fontSize: 18 }} />
        </IconButton>
        </div>
      );
    },
  },
  // {
  //   field: "action",
  //   headerName: roleId == 2 || roleId == 1 ? "Action": "",
  //   disableExport: true ,
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  //   renderCell: (params) => {
  //     // console.log(params.row)
  //     const { row, index } = params;
  //     return (
  //       <div>

  //         {roleId == 2 || roleId == 1 ? 
          
  //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '5px' }}>
  //         <IconButton 
  //         // onClick={() => setOpenDeleteModal(true)}
  //         onClick={() => handleDeleteRow(row, index)} 
  //         aria-label="delete">
  //             <Delete sx={{ color: "red", fontSize: 18 }} />
  //         </IconButton>
  //     </div>
          
  //         :null}

  //       </div>

  //     );
  //   },
  // },
]
console.log(data,"checkkk")

const rows = _.map(data, (val, idx) => ({
  id: idx + 1,
  sno:idx + 1 ,
  // date1: moment(val.created_at).format("DD-MM-YYYY"),
  billNo: val.docno,
  party: val.party_name || "-",
  total_sales_count: val.total_sales_count || "-",
  // time: moment(val.created_at).format("hh:mm A"),
  amt: Math.round(val.total_amount).toFixed(0),
  cess: val.cess_amt,
  dis: val.dis_amt || 0,
  totalamtCount: Math.round(val.final_total).toFixed(0),
  tot: Math.round(val.amount - val.less_amount - val.loyalty_redem ).toFixed(0),
  splDiscount: parseFloat(val.discount_amount).toFixed(0),
  tot_amt: val.total_amount - val.return_amount - val.loyalty_redem - val.less_amount,
  mobile: val.mobile || "-",
  documentDate: moment(val.created_at).format("DD-MM-YYYY"),
  sub_total: parseFloat(val.subtotal_amount).toFixed(0),
  mode: val.mode,
  RetAmt: val.return_amount || 0,
  transactionId: val.transaction_id || '-',
  lessAmount: val.less_amount || 0,
  total_loyalty_earned: parseFloat(val.total_loyalty_earned).toFixed(0) || 0,
  total_loyalty_redemed: Math.round(val.total_loyalty_redemed),
  balance_points: parseFloat(val.balance_points).toFixed(0) || 0
}));

const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  search : search,
  setSearch : setSearch,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
console.log(props,"propsprops");

function handleCheckBox(e){
const {name} = e.target
setPayMode(name)

}
const handleCloseModal = () => {
  setIsModalOpen(false);
  setSelectedRowData(null);
};

const handleDeleteRow = (row, index) => {
  setRowToDelete(row); // Store row data to be deleted
  setDeleteIndex(index); // Store index
  setOpenDeleteModal(true); // Open the modal
};
const handleConfirmDelete = () => {
  const deleteData = {
    outlet_sales_id: rowToDelete.id, 
    outlet_id: cust !== null ? cust.id : outletId, 
    docno: rowToDelete.billNo, 
  };

  axios
    .post(`/v1/outlet_sales_master/delete`, deleteData)
    .then((res) => {
      // Handle success response
      const updatedData = [...data];
      updatedData.splice(deleteIndex, 1); // Remove the deleted row from the state
      setData(updatedData); // Update state with new data
      setOpenDeleteModal(false); // Close modal after deletion
    })
    .catch((err) => {
      console.log(err); // Handle error
    });
};
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  
function handleOutletSalesReport(){
  setLoading(true);
      // Format the dates
      const fromDate = moment(dateLimit.fromDate).format('YYYY-MM-DD');
      const toDate = moment(dateLimit.toDate).format('YYYY-MM-DD');
    
  // const postData = {
  //   from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
  //   to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
  //   customer: cust!==null ? cust.id : outletId
  // }
  let url = `/v1/reports/customersales/${rowsPerPage}/${page + 1}?from_date=${fromDate}&to_date=${toDate}`;
  let searchUrl = `/v1/reports/customersales/${rowsPerPage}/${page + 1}?from_date=${fromDate}&to_date=${toDate}&search=${search}`;

// Check if cust?.id is not 0 and append the outlet_id parameter accordingly
if (cust?.id !== 0) {
  url += `&outlet_id=${cust?.id}`;
}
  axios.get(search === '' ? url : searchUrl,
  // axios.get(`/v1/reports/customersales/${rowsPerPage}/${page}?from_date=${fromDate}&to_date=${toDate}&outlet_id=${cust?.id}`,
    //  postData
    )
  .then(res=>{
    const responseData = res.data.data || [];

    setData(responseData)
    // setData(res.data)
    setPageCount(res.data.meta.pagination.total)
    // setPageCount(responseData);

    // setPage(responseData)
    console.log(res.data.meta.pagination.total,"res.data");
    
  })
  .catch(err=>{
    // dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
  .finally(() => {
    setLoading(false); // Stop loading after request
  });
}
const handleDownloadCSV = async () => {
  try {
    setLoading(true); // Show loading state

    const fromDate = moment(dateLimit.fromDate).format("YYYY-MM-DD");
    const toDate = moment(dateLimit.toDate).format("YYYY-MM-DD");

    // Construct API URL
    let apiUrl = `/v1/reports/customersales/excel?from_date=${fromDate}&to_date=${toDate}`;
    if (cust?.id !== 0) {
      apiUrl += `&outlet_id=${cust?.id}`;
    }

    // Fetch the JSON data
    const response = await axios.get(apiUrl);
    const responseData = response.data;

    if (!responseData || responseData.length === 0) {
      alert("No data available for download.");
      return;
    }

    // Define CSV headers
    const headers = [
      "Mobile",
      "Total Amount",
      "Total Sales Count",
      "Total Loyalty Earned",
      "Total Loyalty Redeemed",
      "Party Name",
      "Balance Points",
      "Created At",
      "Updated At",
    ];

    // Format data into CSV rows
    const csvRows = responseData.map((row) => [
      row.mobile,
      Math.round(row.total_amount), // Round to nearest integer
      Math.round(row.total_sales_count), // Keep as integer
      Math.round(row.total_loyalty_earned), // Round to nearest integer
      Math.round(row.total_loyalty_redemed), // Round to nearest integer
      row.party_name,
      Math.round(row.balance_points), // Round to nearest integer
      moment(row.created_at).format("YYYY-MM-DD"), // Format Date
      moment(row.updated_at).format("YYYY-MM-DD"),
    ]);

    // Convert data to CSV string
    const csvContent = [
      headers.join(","), // Add headers
      ...csvRows.map((row) => row.join(",")), // Add rows
    ].join("\n");

    // Convert CSV string to Blob
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create a download link
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `customer_sales_report_${moment().format("YYYY-MM-DD")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading the file:", error);
    alert("Failed to download the CSV file. Please try again.");
  } finally {
    setLoading(false); // Hide loading state
  }
};

  const tableHeadData = [
    { id:1, label: "S No" },
    { id:2, label: "product name" },
    // { id:3, label: "Doc No" },
    // { id:4, label: "Doc date" },
    { id:3 , label:"MRP"},
    { id:4 , label:"Gst Amnt"},
    { id:5 , label:"Disc Amnt"},
    { id:6, label:"Gst Per"},
    { id:7 , label:"Qty"},
    { id:8 , label:"Rate"},
    {id:9, label: 'Total'}
  ];
  const tableBodyData = _.map(salesLines, (val,idx) => ({
    id:idx,
    sNo:idx+1,
    name:val.pro_name,
    docNo:val.docno,
    docDate:moment(val.docdate).format('DD-MM-YYYY'),
    Mrp:val.mrp,
    gstAmnt:parseFloat(val.gst_amt).toFixed(0),
    splDiscount:val.dis_amt,
    gstPer:val.gst_per,
    Qty:val.qty,
    Rate:parseFloat(val.rate).toFixed(0),
    totalAmount : parseFloat( val.qty * val.rate + val.gst_amt).toFixed(0)
  }))
  console.log(tableBodyData,"tableBodyData");

  
  console.log(totalLoyal);

console.log(totalAmount,"totalAmount")

function handleViewByCustomer(mobile) {
  if (!dateLimit || !dateLimit.fromDate || !dateLimit.toDate) {
    console.error("Date range is missing");
    return;
  }

  const fromDate = moment(dateLimit.fromDate).format('YYYY-MM-DD');
  const toDate = moment(dateLimit.toDate).format('YYYY-MM-DD');
  const url = `v1/reports/bycustomersales/${rowsPerPage}/${page}?mobile=${mobile}&outlet_id=${cust?.id}&from_date=${fromDate}&to_date=${toDate}`;

  axios
    .get(url)
    .then((res) => {
      const responseData = res.data.data || [];
      setCustomerData(responseData);

      // setPageCount(res.data?.length || 0);
      // setPageCount(responseData.length);
      setSalesLines(res.data.data);
      console.log(salesLines,"salesLines112333");
      
      // console.log(responseData, "dataajayyyyyyyyy");
    })
    .catch((err) => {
      console.error(err);
      setCustomerData([]);
    });
}
// const handleModal = () => {
//   setIsModalOpen(false);
//   handleViewByCustomer(params.row.mobile)}
// };
// useEffect(() => {
//   if (data[0]) {
//     const dataArray = Array.isArray(data[0]) ? data : Array.from(data);
//     const total = dataArray.reduce((sum, item) => {
//       return sum + (item && !isNaN(parseFloat(item.total_amount)) ? parseFloat(item.total_amount) : 0);
//     }, 0);
//     setTotalFlag(true)
//     setTotalAmount(total.toFixed(0));
//   }
// }, [data]);


useEffect(() => {
    getSupplierData();
  }, []);
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleOutletSalesReport()
      // handleViewByCustomer()
    }
  },[rowsPerPage, page, dateLimit, cust,search])
  return (
    <Fragment>
      <Helmet><title>Customer Sales Reports</title></Helmet>
      <Typography variant="h6">Customer Sales Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            // options={supplier}
            options={[{id:0 , fullname :"All"} , ...supplier]}

            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname} 
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"
            InputProps={{
              ...params.InputProps,
              readOnly: true,
            }}  
            />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              disabled={roleId != 1 && roleId != 2} 
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              disabled={roleId != 1 && roleId != 2} 
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

          <Grid item md={3} style={{ display: 'flex', alignItems: 'center' }}>
                {/* <CSVLink */}
                
                
                  <Button variant="contained" onClick={handleDownloadCSV}>Download CSV</Button>
                {/* </CSVLink> */}
                </Grid>
      </Grid>
      <Box position="relative" width="100%">
        {/* Table Container */}
        <Paper elevation={2}>
        <CustomTable props={props}/>
        </Paper>
        
        {/* Loader Overlay */}
        {loading && (
          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            position="absolute" 
            top={0} 
            left={0} 
            right={0} 
            bottom={0} 
            bgcolor="rgba(255, 255, 255, 0.7)" // Optional: background color for the overlay
            zIndex={1}
          >
            <CircularProgress size={50}/> {/* Material UI spinner */}
          </Box>
        )}
      </Box>
      <Backdrop open={open} sx={{zIndex:1450}}>
      <DetailsModal
        open={isModalOpen}
        onClose={handleCloseModal}
        data={customerdata}
        salesLines={salesLines}
        
      />
      </Backdrop>
      {/* <Backdrop open={open} sx={{zIndex:1450}}>
        <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop> */}
      <Backdrop open={openDeleteModal} sx={{zIndex:1350}} onClose={() => setOpenDeleteModal(false)}>
  <DeletePage onCancel={setOpenDeleteModal} onSubmit={handleConfirmDelete}/>
</Backdrop>
    </Fragment>
  );
};

export default CustomerWiseSalesReport;
